import React from "react";
const FigmaToCode = () => {
  return <div>hallo test für figma to code </div>;
};

export default FigmaToCode;
